///////////////////////////////////////////////////

import { liveQuoteFormApiConnector } from 'apiConnector/secondary-market/live/form';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, mergeMap, takeUntil } from 'rxjs/operators';
import { liveActions } from 'state/secondaryMarket/live/live.actions';
import { liveThunks } from 'state/secondaryMarket/live/live.thunk';
import type { EpicWithThunk } from 'state/state.common';
import { mapErrorKind } from 'utils/errors/errors';
import type { HttpError } from 'utils/http/httpClient.model';

import { getTabRemoved$ } from '../utils';

export function initLiveFormEpic(): EpicWithThunk {
  return (actions$, _state$, { httpClient }) => {
    const { init } = liveQuoteFormApiConnector(httpClient);

    return actions$.pipe(
      ofType('SECONDARY_MARKET_LIVE_INIT_FORM_FETCH_REQUESTED'),
      mergeMap(({ bcsProductKey, tabId, tradeWay, client, custodian }) =>
        init({ productKeyRequest: bcsProductKey, tradeWay: tradeWay, client, custodian }).pipe(
          takeUntil(getTabRemoved$(actions$, tabId)),
          map(response => liveThunks.initFormFetchedThunk(tabId, response, custodian)),
          catchError((err: HttpError) =>
            of(liveActions.initFormFetchedFailed(tabId, err?.payload?.message, mapErrorKind(err))),
          ),
        ),
      ),
    );
  };
}
